export class TimeframeCalendarDayController {
  /* @ngInject */
  constructor() {
    this.today = new Date();
    this.momentDate = moment(this.date);

    // FIXME scope.vm.dayClasses not visible in link function when defined as class method
    this.dayClasses = () => {
      if (!this.date)
        return {};

      let isSelected = false;
      if (this.isRange || this.isComparison) {
        if (this.startDate && this.endDate) {
          isSelected = this.momentDate.isBetween(
            moment(this.startDate).subtract(1, 'day'),
            moment(this.endDate).add(1, 'day')
          )
        } else if (this.startDate && this.hoveredDate) {
          isSelected = this.momentDate.isBetween(
            moment(this.startDate).subtract(1, 'day'),
            moment(this.hoveredDate).add(1, 'day')
          )
        } else if (this.startDate) {
          isSelected = this.momentDate.isSame(this.startDate, 'day');
        }
      } else if (this.selectedDate) {
        isSelected = this.momentDate.isSame(this.selectedDate, 'day');
      }

      let isStartDate = false;
      let isEndDate = false;
      if (this.isRange || this.isComparison) {
        if (this.startDate) {
          isStartDate = this.momentDate.isSame(this.startDate, 'day');
        }
        if (this.endDate) {
          isEndDate = this.momentDate.isSame(this.endDate, 'day');
        } else if (this.hoveredDate) {
          isEndDate = this.momentDate.isSame(this.hoveredDate, 'day');
        }
      } else {
        isStartDate = isEndDate = true;
      }

      let isToday = this.momentDate.isSame(this.today, 'day');
      let isFuture = this.date.getTime() > this.today.getTime();
      let isDifferentMonth = this.date.getFullYear() != this.current.getFullYear() ||
        this.date.getMonth() != this.current.getMonth();

      let classes = {addClasses: [], removeClasses: []};
      let valueToClassName = (value) => value ? 'addClasses' : 'removeClasses';

      classes[valueToClassName(isSelected)].push('is-active');
      classes[valueToClassName(isFuture)].push('is-disabled');
      classes[valueToClassName(isDifferentMonth)].push('is-different-month');
      classes[valueToClassName(isStartDate)].push('c-calendar__day--start-range');
      classes[valueToClassName(isEndDate)].push('c-calendar__day--end-range');
      classes[valueToClassName(isToday)].push('c-calendar__day--today');

      return classes;
    };

    this.isRange = /range/.test(this.mode);
    this.isComparison = /comparison/.test(this.mode);
  }
}

export function TimeframeCalendarDayComponent() {
  return {
    controller: TimeframeCalendarDayController,
    restrict: 'A',
    controllerAs: 'vm',
    require: "^timeframeCalendar",
    scope: {
      mode: '=?',
      hoveredDate: '=?',
      current: '=?',
      date: '=?',
      dayClasses: '=?',
      selectedDate: '=?',
      startDate: '=?',
      endDate: '=?'
    },
    bindToController: true,
    link: function(scope, element, attrs, timeframeCalendarCtrl) {
      let $element = $(element);

      let updateDayClasses = () => {
        let {addClasses, removeClasses} = scope.vm.dayClasses();
        $element
          .addClass(addClasses.join(' '))
          .removeClass(removeClasses.join(' '));
      };

      scope.$watchGroup(['vm.startDate', 'vm.endDate', 'vm.hoveredDate', 'vm.selectedDate'], updateDayClasses);
      // TODO refactor using RX events
      // * selection in inputs need to trigger event
      //updateDayClasses();
      //timeframeCalendarCtrl.events.on('changed', () => setTimeout(updateDayClasses));
      //timeframeCalendarCtrl.events.on('hovered', () => setTimeout(updateDayClasses));
    }
  };
};

export default angular.module('app.datetime.timeframe-calendar-day', [])
  .directive('timeframeCalendarDay', TimeframeCalendarDayComponent);



/** WEBPACK FOOTER **
 ** ./src/common/datetime/timeframe-calendar-day.js
 **/